<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'EventMain'
}
</script>

<style></style>
